import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { APP_TITLE } from './utils/iconMappings';
import InteractionDetails from './screens/InteractionDetails';
import InteractionDetailsGlobal from './screens/InteractionDetailsGlobal';
import LiveAssistHub from './screens/LiveAssistHub';
import LiveAssistLive from './screens/LiveAssistLive';
import LiveAssistReplay from './screens/LiveAssistReplay';
import LiveAssistLegacyRedirect from './screens/LiveAssistLegacyRedirect';
import InteractionSearchList from './screens/InteractionSearchList';
import { LayoutProvider } from './contexts/LayoutContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './screens/Login';
import './styles/variables.css';
import './styles/typography.css';
import './styles/common.css';
import TestAudio from './screens/TestAudio';
import MomentsList from './screens/MomentsList';
import MomentListTable from './screens/MomentListTable';
import MomentView from './screens/MomentView';
import MomentForm from './screens/MomentForm';
import EvaluationForm from './screens/EvaluationForm';
import LandingPage from './screens/LandingPage';
import LiveDemoGallery from './screens/LiveDemoGallery';
import LiveDemoDetail from './screens/LiveDemoDetail';
import LiveDemoPlayer from './screens/LiveDemoPlayer';
import ExecutionList from './screens/ExecutionList';
import UtteranceListTable from './screens/UtteranceListTable';
import UtteranceSourceDetail from './screens/UtteranceSourceDetail';
import MetadataUpload from './screens/MetadataUpload';
import { PATH_SEGMENTS, route } from './config/paths';
import { MarketingThemeProvider } from './contexts/MarketingThemeContext';
import './styles/marketingThemes.css';
const App: React.FC = () => {
  // Set document title
  React.useEffect(() => {
    document.title = APP_TITLE;
  }, []);
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <LayoutProvider>
            <MarketingThemeProvider>
            <Layout>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path={route(PATH_SEGMENTS.LIVE_DEMO)} element={<LiveDemoGallery />} />
              <Route path={route(PATH_SEGMENTS.LIVE_DEMO, ':demoId')} element={<LiveDemoDetail />} />
              <Route
                path={route(PATH_SEGMENTS.LIVE_DEMO, ':demoId', PATH_SEGMENTS.LIVE_DEMO_PLAY)}
                element={<LiveDemoPlayer />}
              />

              {/* Protected routes */}
              <Route path="/interactions" element={
                <ProtectedRoute>
                  <InteractionSearchList />
                </ProtectedRoute>
              } />
              <Route path="/interaction/:id" element={
                <ProtectedRoute>
                  <InteractionDetails />
                </ProtectedRoute>
              } />
              <Route path="/interaction-global/:id" element={
                <ProtectedRoute>
                  <InteractionDetailsGlobal />
                </ProtectedRoute>
              } />
              <Route path="/live-assist/live" element={
                <ProtectedRoute>
                  <LiveAssistLive />
                </ProtectedRoute>
              } />
              <Route path="/live-assist/replay/:id" element={
                <ProtectedRoute>
                  <LiveAssistReplay />
                </ProtectedRoute>
              } />
              <Route path="/live-assist/replay" element={
                <ProtectedRoute>
                  <LiveAssistReplay />
                </ProtectedRoute>
              } />
              <Route path="/live-assist/:interactionId" element={
                <ProtectedRoute>
                  <LiveAssistLegacyRedirect />
                </ProtectedRoute>
              } />
              <Route path="/live-assist" element={
                <ProtectedRoute>
                  <LiveAssistHub />
                </ProtectedRoute>
              } />

              {/* Moment Routes */}
              <Route path="/moments" element={
                <ProtectedRoute>
                  <MomentListTable />
                </ProtectedRoute>
              } />
              <Route path="/utterances" element={
                <ProtectedRoute>
                  <UtteranceListTable />
                </ProtectedRoute>
              } />
              <Route path="/utterance/:utsid" element={
                <ProtectedRoute>
                  <UtteranceSourceDetail />
                </ProtectedRoute>
              } />
              <Route path="/metadata" element={
                <ProtectedRoute>
                  <MetadataUpload />
                </ProtectedRoute>
              } />
              {/* <Route path="/momenttable" element={
                <ProtectedRoute>
                  <MomentListTable />
                </ProtectedRoute>
              } /> */}
              <Route path="/momentview/:id" element={
                <ProtectedRoute>
                  <MomentView />
                </ProtectedRoute>
              } />
              <Route path="/moment" element={
                <ProtectedRoute>
                  <MomentForm />
                </ProtectedRoute>
              } />
              <Route path="/moment/:id" element={
                <ProtectedRoute>
                  <MomentForm />
                </ProtectedRoute>
              } />
              <Route path="/moment/edit/:id" element={
                <ProtectedRoute>
                  <MomentForm />
                </ProtectedRoute>
              } />
              <Route path="/moment/new" element={
                <ProtectedRoute>
                  <MomentForm />
                </ProtectedRoute>
              } />
              
              <Route path="/evalform/" element={
                <ProtectedRoute>
                  <EvaluationForm />
                </ProtectedRoute>
              } />
              <Route path="/evalform/:id" element={
                <ProtectedRoute>
                  <EvaluationForm />
                </ProtectedRoute>
              } />

              {/* Execution Routes */}
              <Route path="/execution/:type" element={
                <ProtectedRoute>
                  <ExecutionList />
                </ProtectedRoute>
              } />

              {/* Existing test route */}
              <Route path="/test-audio/:id" element={
                <ProtectedRoute>
                  <TestAudio src={`http://localhost:8000/audio/12`} />
                </ProtectedRoute>
              } />

              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </Layout>
            </MarketingThemeProvider>
          </LayoutProvider>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;



